import { TypographyStyles } from '@/styles'
import { Image, Text } from '@/ui'
import { SignupPageLayout } from '../SignupPageLayout'
import { KeepInTouchCard } from '@/features/user/signup/KeepInTouchCard'
import { SignupFooter } from '@/features/user/signup/SignupFooter'
import { CONSULT_COPY } from './consult.copy'

export const Consult = () => (
  <SignupPageLayout
    hideProgress
    maxWidth="wide"
    footer={
      <SignupFooter
        backText="Return to Site"
        onBack={() => {
          window.location.href = CONSULT_COPY.returnUrl
        }}
        continueText={CONSULT_COPY.ctaText}
        onContinue={() => {
          window.location.href = CONSULT_COPY.bookingUrl
        }}
      />
    }
  >
    <div className="flex flex-row gap-14">
      <div className="flex-4 self-start flex flex-col space-y-4 mx-4">
        <Image
          src="https://heard-images.s3.amazonaws.com/assets/messages.svg"
          alt="chat bubbles with question mark"
          height={120}
          width={120}
        />

        <Text variant={TypographyStyles.DISPLAY_MD} className="mt-4">
          {CONSULT_COPY.heading}
        </Text>

        <Text variant={TypographyStyles.BODY_SM} className="mt-4">
          {CONSULT_COPY.body}
        </Text>
      </div>
      <div className="self-center flex-3">
        <KeepInTouchCard />
      </div>
    </div>
  </SignupPageLayout>
)
